import React from "react";

const SurveyProgressBar = ({ barHeight = "", percentage = 0 }) => {
  const handleColor = (percentage) => {
    if (percentage < 50) {
      return "bg-secondaryRed";
    }
    if (percentage < 75) {
      return "bg-primaryYellow";
    }
    return "bg-secondaryGreen";
  };

  return (
    <div
      className={`overflow-hidden text-xs flex rounded bg-gray-200 ${barHeight} w-32`}
    >
      <div
        style={{
          width: `${percentage}%`,
          textAlign: percentage === 100 ? "center" : "right",
        }}
        className={`shadow-md flex flex-col text-white justify-center pr-[3px] ${handleColor(
          percentage
        )} text-sm opacity-70`}
      >
        {percentage >= 50 ? percentage + "%" : ""}
      </div>
      {percentage < 50 && (
        <div
          className="flex flex-col pl-[3px] whitespace-nowrap text-black justify-center bg-transparent text-sm opacity-70 "
          style={{
            width: `${100 - percentage}%`,
            textAlign: percentage === 0 ? "center" : "left",
          }}
        >
          {percentage + "%"}
        </div>
      )}
    </div>
  );
};

export default SurveyProgressBar;
